import React from 'react'
import { Link } from 'react-router-dom'

import Logo from './logo'
import './navigation.css'

const Navigation = (props) => {
  return (
    <nav className="navigation-thq-navigation-section-elm navigation-section">
      <div className="navigation-texture"></div>
      <div className="navigation-bar">
        <div className="navigation-brand-group">
          <Link to="/" className="navigation-navlink1">
            <div className="navigation-logo-link">
              <Logo isOnDarkBackground></Logo>
            </div>
          </Link>
        </div>
        <div className="navigation-actions-group">
          <a
            href="tel:954-471-5525"
            className="navigation-thq-navigation-contact-dummy-elm navigation-contact-dummy"
          >
            954-471-5525 TO BOOK
          </a>
          <label
            aria-label="Open menu"
            htmlFor="navigation-menu-toggle"
            className="navigation-hamburger"
          >
            <svg
              fill="none"
              width="24"
              height="24"
              stroke="currentColor"
              viewBox="0 0 24 24"
              aria-hidden="true"
              strokeWidth="2"
              strokeLinecap="round"
            >
              <line x1="4" x2="20" y1="6" y2="6"></line>
              <line x1="4" x2="20" y1="12" y2="12"></line>
              <line x1="4" x2="20" y1="18" y2="18"></line>
            </svg>
          </label>
        </div>
      </div>
      <input
        type="checkbox"
        id="navigation-menu-toggle"
        className="navigation-thq-navigation-checkbox-elm navigation-checkbox"
      />
      <div className="navigation-mobile-overlay">
        <div className="navigation-overlay-texture"></div>
        <div className="navigation-overlay-header">
          <Link to="/" className="navigation-navlink2">
            <div className="navigation-logo-link">
              <Logo isOnDarkBackground></Logo>
            </div>
          </Link>
          <label
            aria-label="Close menu"
            htmlFor="navigation-menu-toggle"
            className="navigation-close"
          >
            <svg
              fill="none"
              width="24"
              height="24"
              stroke="currentColor"
              viewBox="0 0 24 24"
              aria-hidden="true"
              strokeWidth="2"
              strokeLinecap="round"
            >
              <line x1="18" x2="6" y1="6" y2="18"></line>
              <line x1="6" x2="18" y1="6" y2="18"></line>
            </svg>
          </label>
        </div>
        <div className="navigation-overlay-links">
          <Link to="/" className="navigation-navlink3">
            <div className="navigation-overlay-link-dummy">
              <span>Home</span>
            </div>
          </Link>
          <span
            data-planned-page="Party Rentals"
            className="navigation-overlay-link-dummy"
          >
            Party Rentals
          </span>
          <span
            data-planned-page="Furniture &amp; Decor"
            className="navigation-overlay-link-dummy"
          >
            Seating &amp; Tables
          </span>
          <span className="navigation-overlay-link-dummy">Shelters</span>
          <span className="navigation-overlay-link-dummy">Decor</span>
          <span
            data-planned-page="Concession Rentals"
            className="navigation-overlay-link-dummy"
          >
            Concessions
          </span>
          <span
            data-planned-page="Marquee Numbers &amp; Letters"
            className="navigation-overlay-link-dummy"
          >
            Marquee Letters
          </span>
          <span
            data-planned-page="Packages &amp; Add‑Ons"
            className="navigation-overlay-link-dummy"
          >
            Bundles &amp; Packages
          </span>
          <span className="navigation-overlay-link-dummy">
            Ponies &amp; Petting Zoo
          </span>
          <span className="navigation-overlay-link-dummy">Trackless Train</span>
          <span className="navigation-overlay-link-dummy">
            In-Costume Entertainers
          </span>
          <span className="navigation-overlay-link-dummy">Face Painting</span>
          <span className="navigation-overlay-link-dummy">Balloon Artists</span>
          <div className="navigation-overlay-footer">
            <span
              data-planned-page="Request a Booking"
              className="navigation-btn-dummy"
            >
              Book Your Event
            </span>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default Navigation
